import {
  Button,
  Form,
  Input,
  Switch,
  Radio,
  Select,
  InputNumber,
  Tag,
  Upload,
  Space,
  Row,
  Col,
  Cascader,
  message,
} from 'antd'
import { InboxOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import './newContent.css'
import AddContent from './components/addContent/addContent'
import { useEffect, useState } from 'react'
import { MyValidateMessages } from '../../utils/validateMessaage'
import UploadOnePicture from '../../components/upLoadOnePicture/uploadPicture'
import {
  changeShare,
  freshToken,
  getCategories,
  newShare,
  shareDetail,
} from '../../api/api'
import UploadMultiplePicture from '../../components/uploadMultiplePicture/uploadMultiplePicture'
import { useLocation, useNavigate } from 'react-router-dom'
import UploadlistTypeMultiplePicture from '../../components/uploadlistTypeMultiplePicture/uploadlistTypeMultiplePicture'
import RichTextEditor from '../../components/richText/richText'

export default function NewContent() {
  const [newContent, setNewContent] = useState([{ 1: 1 }, { 1: 1 }])
  const [data, setData] = useState()
  const [form] = Form.useForm()
  const [dictionary, setDictionary] = useState([]) //字典
  const [categoryName, setCategoryName] = useState({})
  const { Option } = Select
  const layout = {
    labelCol: {
      span: 2,
    },
    wrapperCol: {
      span: 8,
    },
  }
  const navigate = useNavigate()

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (newurl) => {
    setUrl(newurl)
    form.setFieldValue('image', newurl)
    // console.log(url);
  }
  //向父组件传递图片网址
  const [multipleImgUrl, setMultipleImgUrl] = useState([])

  //向父组件传递富文本内容
  const [richText, setRichText] = useState([])

  //获取初始字典初始数据
  useEffect(() => {
    getCategories({
      params: { type: Number(localStorage.getItem('contentType')) },
    }).then((res) => {
      setDictionary(res.data.data.Categories)
      // console.log(JSON.stringify(res.data.data.Categories))
    })
  }, [])

  //编辑内容时的初始化
  const location = useLocation()
  const info = location?.state?.info ?? {}

  const findName = (list, target) => {
    for (let subList of list) {
      if (subList.ID === target) {
        return subList.Name
      }
      if (subList.SubCategories) {
        let res = findName(subList.SubCategories, target)
        if (res) return res
      }
    }
  }

  const cascaderChange = (val) => {
    const id = val.pop()
    // console.log(dictionary,id);
    const name = findName(dictionary, id)
    console.log(id, name)
    setCategoryName({ id: id, name: name })
    console.log(form.getFieldValue('category_id'))
    form.setFieldValue('category_id', id)
  }

  const wait = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(categoryName)
      }, 300)
    })
  }

  //设置cascader的展示内容
  const displayRender = () => {
    // console.log(categoryName);
    // console.log(label, options)
    return <span key={categoryName.id}>{categoryName.name}</span>
  }

  //初始化cascader，再获取一次dictionary保证dictionary不为空
  useEffect(() => {
    if (location.state && location.state.state === 'edit') {
      console.log('edit')
      Promise.all([
        getCategories({
          params: { type: Number(localStorage.getItem('contentType')) },
        }),
        shareDetail(info.id),
      ]).then((res) => {
        // console.log(res);
        const data = res[1].data.data
        const list = res[0].data.data.Categories
        setData(data)
        setUrl(data.image)
        setMultipleImgUrl(() => {
          //将contents中的images全部取出来存在一个数组里
          const MultipleImg = []
          const contents = data.contents
          contents.forEach((item, index) => {
            // console.log('item', item)
            MultipleImg[index] = item.images
          })
          console.log('MultipleImg', MultipleImg)
          return MultipleImg
        })
        //将category数字转化成文字
        const category_id = data.category_id
        const Category_name = findName(list, category_id)
        setCategoryName({ id: category_id, name: Category_name })
        form.setFieldsValue(data)
      })
    }
  }, [])

  const onFinish = (values) => {
    form.setFieldValue('image', url)
    console.log(url)
    form.setFieldValue('category_id', categoryName.id)
    form.setFieldValue((e) => {
      console.log('formfiled:', e)
    })

    form.validateFields().then((res) => {
      //定义选填内容
      // console.log(res.contents)
      console.log(multipleImgUrl)
      const contents =
        res.contents === undefined
          ? []
          : res.contents.map((item, index) => {
              return {
                images: multipleImgUrl[index] ?? [],
                id: index,
                sub_title: item.sub_title,
                text: richText[index] ?? '',
              }
            })
      // console.log('content data:', res)
      const putparams = {
        ...res,
        category_id: Array.isArray(res.category_id)
          ? res.category_id[1] ?? res.category_id[0]
          : res.category_id,
        contents: contents,
        id: data?.ID,
        type: Number(localStorage.getItem('contentType')),
      }

      const postparams = {
        ...res,
        category_id: Array.isArray(res.category_id)
          ? res.category_id[1] ?? res.category_id[0]
          : res.category_id,
        contents: contents,
        type: Number(localStorage.getItem('contentType')),
      }
      console.log(putparams, postparams)
      if (location?.state?.state === 'edit') {
        changeShare(putparams)
          .then((res) => {
            console.log(res)
            message.success('编辑内容成功！')
            if (localStorage.getItem('contentType') === '1') {
              navigate('/studyManage', { replace: true })
            } else if (localStorage.getItem('contentType') === '2') {
              navigate('/rentManage', { replace: true })
            } else if (localStorage.getItem('contentType') === '3') {
              navigate('/beforeTravelManage', { replace: true })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        newShare(postparams)
          .then((res) => {
            console.log(res)
            message.success('新建内容成功！')
            if (localStorage.getItem('contentType') === '1') {
              navigate('/studyManage', { replace: true })
            } else if (localStorage.getItem('contentType') === '2') {
              navigate('/rentManage', { replace: true })
            } else if (localStorage.getItem('contentType') === '3') {
              navigate('/beforeTravelManage', { replace: true })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  const cancelSubmit = () => {
    if (localStorage.getItem('contentType') === '1') {
      navigate('/studyManage', { replace: true })
    } else if (localStorage.getItem('contentType') === '2') {
      navigate('/rentManage', { replace: true })
    } else if (localStorage.getItem('contentType') === '3') {
      navigate('/beforeTravelManage', { replace: true })
    }
  }

  const add = () => {
    setNewContent([...newContent, {}])
  }
  const deleteContent = (idx) => {
    newContent.map((info, index) => {
      if (index === idx) {
        newContent.splice(idx, 1)
        setNewContent(() => {
          return [...newContent]
        })
        console.log('delete:', info)
      }
    })
  }

  const [fresh, setFresh] = useState(false)
  useEffect(() => {
    console.log('fileList', fresh)
  }, [fresh])

  //信息选填的图片的URL传递
  const changeMultipleImg = (index) => (newUrl) => {
    console.log('newUrl', newUrl)
    setFresh((pre) => !pre)
    setMultipleImgUrl((pre) => {
      // console.log('the initial img url arr',pre)
      // console.log(newUrl)
      // console.log(pre,pre.images);
      const newData = pre[index] ?? []
      newData.push(newUrl)
      // console.log(newData)
      pre[index] = newData
      return pre
    })
  }
  //信息选填的图片的URL传递
  const deliveryRichtext = (index) => (newText) => {
    // console.log("newText", newText);

    setRichText((pre) => {
      pre[index] = newText
      return pre
    })

    // 传递富文本编辑器内容给form表达，完成必填项检验
    let contentList = form.getFieldValue('contents')
    contentList[index].text = newText
    form.setFieldValue('contents', contentList)
  }

  return (
    <div className="newContent">
      <Form
        {...layout}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={MyValidateMessages}
        form={form}
        // initialValues={data ?? {}}
      >
        <Row>
          <Col span={12}>
            {/* 内容标题 */}
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 16,
              }}
              name="title"
              label="内容标题"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="上限50字" />
            </Form.Item>
          </Col>
          {/* 是否部分可见 */}
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 5,
              }}
              name="is_partially_visible"
              label="是否部分可见"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: '请选择是否部分可见',
                },
              ]}
            >
              <Select placeholder="请选择">
                <Option value={1}>是</Option>
                <Option value={0}>否</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 内容分类 */}
        <Form.Item
          name="category_id"
          label="内容分类"
          hasFeedback
          rules={[
            {
              required: true,
              validator: async (rule, value) => {
                // console.log(value);
                const data = await wait()
                // console.log(data);
                if (data?.id ?? false) {
                  // console.log("yes");
                  return Promise.resolve()
                } else {
                  console.log('error')
                  return Promise.reject(new Error('内容分类是必填项！'))
                }
              },
            },
          ]}
        >
          <Cascader
            options={dictionary}
            allowClear={false}
            fieldNames={{
              value: 'ID',
              label: 'Name',
              children: 'SubCategories',
            }}
            displayRender={displayRender}
            onChange={cascaderChange}
            key={categoryName}
            placeholder="请选择"
          ></Cascader>
        </Form.Item>

        {/* 内容首图 */}
        <Form.Item
          name="image"
          label="内容首图"
          style={{ textAlign: 'left' }}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <UploadOnePicture
            key={data}
            deliverUrl={setImgUrl}
            image={data?.image}
          />
        </Form.Item>

        {/* 信息选填 */}
        <Form.List
          name="contents"
          // initialValue={[1, 2, 3]}
        >
          {(fields, { remove, add, move }) => {
            return (
              <>
                {fields.map((field, index) => (
                  <div key={index}>
                    <Row>
                      <Col span={12}>
                        <Form.Item
                          labelCol={{
                            span: 4,
                          }}
                          wrapperCol={{
                            span: 16,
                          }}
                          label={'标题' + Number(index + 1)}
                          name={[field.name, 'sub_title']}
                          rules={[
                            {
                              required: true,
                              max: 20,
                            },
                          ]}
                        >
                          <Input placeholder="请输入标题，不超过20字" />
                        </Form.Item>
                      </Col>
                      <Col span={11}>
                        <div
                          style={{
                            cursor: 'pointer',
                            color: '#1890ff',
                            paddingTop: '1%',
                          }}
                          onClick={() => {
                            remove(index)
                          }}
                        >
                          删除
                        </div>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={[field.name, 'text']}
                          // name="text"
                          label={'内容' + Number(index + 1)}
                          labelCol={{
                            span: 4,
                          }}
                          wrapperCol={{
                            span: 16,
                          }}
                          rules={[
                            {
                              required: true,
                              // max: 2000,
                            },
                          ]}
                        >
                          <RichTextEditor
                            defaultContent={data?.contents[index]?.text ?? ''}
                            deliveryRichtext={deliveryRichtext(index)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={16}>
                        {/* 内容图片 (最多可以上传9张图片),之后再改进*/}
                        <Form.Item
                          label={'图片' + Number(index + 1)}
                          labelCol={{ span: 3 }}
                          name={[field.name, 'images']}
                          style={{ textAlign: 'left' }}
                        >
                          <UploadMultiplePicture
                            deliverUrl={changeMultipleImg(index)}
                            key={data}
                            count={1}
                            images={data?.contents[index]?.images ?? []}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                ))}

                <Form.Item className={'text-center'}>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ width: '75vw', marginLeft: '38px' }}
                  >
                    新增内容部分
                  </Button>
                </Form.Item>
              </>
            )
          }}
        </Form.List>

        <Form.Item
          wrapperCol={{
            ...layout.wrapperCol,
            offset: 20,
            span: 24,
          }}
        >
          <div className="buttonGroup">
            <Button onClick={cancelSubmit}>取消</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '20px' }}
              // onClick={onFinish}
            >
              提交
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}
